import { render, staticRenderFns } from "./scoreModal.vue?vue&type=template&id=1da15d51&scoped=true"
import script from "./scoreModal.vue?vue&type=script&lang=js"
export * from "./scoreModal.vue?vue&type=script&lang=js"
import style0 from "./scoreModal.vue?vue&type=style&index=0&id=1da15d51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da15d51",
  null
  
)

export default component.exports